import React from "react";
import Layout from "@hoc/layouts/Layout";
import FishingTechniqueEUIndex from "@components/FishingTechniqueEU/FishingTechniqueEUIndex";

const FishingTechniquesEUPage = () => {
  return (
    <Layout>
      <FishingTechniqueEUIndex />
    </Layout>
  );
};

export default FishingTechniquesEUPage;
